import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_hdr_RowClass, bl_wf_issue_hdr_RowInterface} from '../../../dbschema/bl_wf_issue_hdr.model';

export class WfIssueHdrContainerModel extends BaseContainerModel {
  issueHdr: bl_wf_issue_hdr_RowInterface = new bl_wf_issue_hdr_RowClass();
}
